import type { InternalAuditReportRegisterResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetInternalAuditReportsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetInternalAuditReportsRegisterArgs = Record<string, never>;

export const useGetInternalAuditReportsRegister = createQueryHook<
  UseGetInternalAuditReportsRegisterArgs,
  InternalAuditReportRegisterResponseRow[],
  GetInternalAuditReportsQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.internalAuditReport.register.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    internal_audit_report: data.map((report) => ({
      ...report,
      assessedItems: report.assessmentResults || [],
    })),
  }),
  graphqlDocument: GetInternalAuditReportsDocument,
});
